module.exports = __webpack_public_path__ + "static/media/benefit_2.b258e692.svg";